export default `mutation cardDisable ($recurringDetailReference: String!){
  cardDisable (recurringDetailReference: $recurringDetailReference)
}`
